import { render, staticRenderFns } from "./BrandCampaignList.vue?vue&type=template&id=3bab8734&scoped=true&"
import script from "./BrandCampaignList.vue?vue&type=script&lang=js&"
export * from "./BrandCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./BrandCampaignList.vue?vue&type=style&index=0&id=3bab8734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab8734",
  null
  
)

export default component.exports